import { OrderSummaryState, OrderSummaryAction } from './orderSummary.types';

export const initialState: OrderSummaryState = {
  orderSummary: {
    customer: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailAddress: '',
      address: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipCode: ''
      }
    },
    vehicle: {
      id: 0,
      year: 0,
      odometer: 0,
      make: '',
      model: '',
      trim: '',
      vin: '',
      engineDescription: '',
      unlockDateTime: '',
      inventoryType: ''
    },
    payment: {
      creditFromPreviousOrder: 0,
      isShippingFeeNonRefundable: false,
      refundDue: 0,
      dueAtOrder: 0,
      cashDown: 0,
      shippingFee: 0,
      paymentAccounts: []
    },
    vinEtching: {
      declined: false
    },
    marketing: {
      hashedEmailAddress: '',
      hashedFirstName: '',
      hashedLastName: '',
      hashedDateOfBirth: '',
      hashedBirthMonthAndDay: '',
      hashedBirthYear: '',
      hashedCity: '',
      hashedState: '',
      hashedZip5: '',
      hashedPhoneNumber: ''
    },
    swap: {},
    totals: {
      totalPrice: 0,
      vehicleStickerPrice: 0,
      taxes: 0,
      tradeInTaxSavings: 0,
      taxesWithoutTrade: 0,
      fees: 0,
      discounts: 0,
      rebates: 0,
      incentives: 0,
      deliveryCharge: 0,
      shippingFee: 0,
      tradeInValue: 0,
      products: 0,
      savingsAndIncentives: 0
    },
    fees: [],
    discounts: [],
    rebates: [],
    incentives: [],
    experiments: []
  }
};

export const orderSummaryReducer = (state: OrderSummaryState, action: OrderSummaryAction) => {
  switch (action.type) {
    case 'SET_ORDER_SUMMARY':
      return {
        ...state,
        orderSummary: action.payload
      };
    default:
      throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
  }
};
